import React from 'react';
import PropTypes from 'prop-types';
/**
 * Table header cell with label separated by new line
 *
 * @param {{}} props
 * @constructor
 */
const MultiLineHeader = props => (
    <span>
        {props.displayName.map((row, index) => {
            let displayText = '';
            let className = false;

            if (typeof row === 'object') {
                displayText = row.text;
                className = row.className;
            } else {
                displayText = row;
            }

            if (index) {
                return <span className={className} key={index}>{displayText}</span>;
            }

            return <span className={className} key={index}>{displayText}</span>;
        })}
    </span>
);

MultiLineHeader.propTypes = {
    /**
     * Array of header lines to display
     */
    displayName: PropTypes.array.isRequired
};

export default MultiLineHeader;



// WEBPACK FOOTER //
// ./src/js/components/DataTable/MultiLineHeader.js